import {
  AbstractControlOptions,
  FormArray,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { AuthentificationService } from '@app/authentification/authentification.service';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { PledgeDocumentRead } from '@app/forms/subscription/definition/interface/Pledge';
import { CompanyFieldType } from '@app/forms/subscription/definition/interface/enum';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';
import {
  calculateDateExpiredAddMonths,
  calculateDateExpiredSubtractMonths,
} from '../utile';

export abstract class EaDocumentFormBuilder extends PrFormAbstract {
  isConsultant: boolean;

  constructor(
    protected formConstructor: PrFormConstructor,
    protected subscriptionFacade: SubscriptionFacadeService,
    protected authenticationService: AuthentificationService,
  ) {
    super(formConstructor);
    authenticationService.isConsultant().subscribe(consultant => {
      this.isConsultant = consultant;
    });
  }

  generate(entity: PledgeDocumentRead, option) {
    let options: AbstractControlOptions = {};
    const JUSTIFICATIF_ORGINE_DES_FONDS_DOCUMENT_REQUIRED =
      option?.additionalQuestions?.find(
        q => q?.id === CompanyFieldType.JUSTIFICATIF_ORGINE_DES_FONDS_DOCUMENT,
      )?.required === 'MANDATORY';

    return this.formBuilder.group(
      {
        id: [entity?.id || null],
        document: [entity ? entity?.document : null, Validators.required],
        label: [entity?.label || null],
        dateCreated: [entity?.dateCreated || null],
        reviewed: [entity?.reviewed || null],
        isSigned: [entity?.isSigned || null],
        category: ['CIVIL_STATE'],
        dateExpired: [
          entity?.dateExpired
            ? calculateDateExpiredSubtractMonths(entity?.dateExpired)
            : null,
          [
            JUSTIFICATIF_ORGINE_DES_FONDS_DOCUMENT_REQUIRED
              ? Validators.required
              : Validators.nullValidator,
          ],
        ],

        accountId: [entity ? entity?.accountId : null],
      },
      options,
    );
  }

  extractDocument() {
    const pledge = this.subscriptionFacade.getPledge();

    let uploadForm: FormGroup = this.formBuilder.group({
      category: 'CIVIL_STATE',
      document: this.utilsService.emptyIsNull(this.form.value.document),
      dateExpired: this.utilsService.emptyIsNull(
        calculateDateExpiredAddMonths(this.form.value.dateExpired),
      ),
      accountId: this.utilsService.emptyIsNull(this.form.value.accountId),
      id: this.utilsService.emptyIsNull(this.form.value.id),
      ownerIds: this.utilsService.emptyIsNull(this.findOwners(pledge)),
      label: this.utilsService.emptyIsNull(this.form.value.label),
      dateCreated: this.utilsService.emptyIsNull(this.form.value.dateCreated),
      reviewed: !!this.isConsultant,
      isSigned: false,
    });
    return uploadForm;
  }

  findOwners(pledge: any) {
    let ownerIds = new FormArray([]);
    if (pledge?.parameters?.subscriberType) {
      if (
        pledge?.parameters?.subscriberType === 'COMPANY' &&
        pledge?.owners?.length
      ) {
        ownerIds.push(new FormControl(pledge.owners[0].company.id));
      } else if (pledge?.owners?.length) {
        pledge.owners.forEach(owner => {
          ownerIds.push(new FormControl(owner.ownerId));
        });
      }
    }
    return ownerIds;
  }
}
